export default __webpack_public_path__ + "static/media/snehal.194aafa2.jpg";